import _createClass from '@babel/runtime/helpers/createClass';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import 'classnames';
import typographyStyles from '../Typography/Typography.module.css.js';
import styles from './Tooltip.module.css.js';

var EXTRA_RIGHT_OFFSET = 22;
var Tooltip = /*#__PURE__*/_createClass(function Tooltip(elementToInsertInto, width, testAttribute) {
  var _this = this;
  _classCallCheck(this, Tooltip);
  _defineProperty(this, "tooltip", void 0);
  _defineProperty(this, "width", void 0);
  _defineProperty(this, "mousemove", function (e, upperMsg, lowerMsg) {
    _this.updatePosition(e);
    _this.replaceContent(upperMsg, lowerMsg);
  });
  _defineProperty(this, "mouseleave", function () {
    _this.tooltip.style.opacity = 0;
  });
  _defineProperty(this, "destructor", function () {
    _this.tooltip.remove();
  });
  _defineProperty(this, "updatePosition", function (e) {
    var mouseX = e.pageX;
    var mouseY = e.pageY;
    var body = document.body;
    var horizontalOffset;
    var offsetParentDimensions = _this.tooltip.offsetParent.getBoundingClientRect();
    var offsetX = offsetParentDimensions.left + window.scrollX;
    var offsetY = offsetParentDimensions.top + window.scrollY;
    if (_this.width && body && body.scrollWidth - mouseX < _this.width) {
      horizontalOffset = mouseX - _this.width - 9 - EXTRA_RIGHT_OFFSET - offsetX;
    } else {
      horizontalOffset = mouseX + EXTRA_RIGHT_OFFSET - offsetX;
    }
    _this.tooltip.style.left = "".concat(horizontalOffset, "px");
    _this.tooltip.style.top = "".concat(mouseY - offsetY + 5, "px");
    _this.tooltip.style.opacity = 1;
  });
  _defineProperty(this, "replaceContent", function (upperMsg, lowerMsg) {
    _this.tooltip.textContent = '';
    var upperMsgEl = document.createElement('span');
    upperMsgEl.textContent = upperMsg.text;
    if (upperMsg.isBold) {
      upperMsgEl.classList.add(typographyStyles.smallText_semibold);
    }
    _this.tooltip.appendChild(upperMsgEl);
    if (lowerMsg) {
      var lowerMsgEl = document.createElement('p');
      lowerMsgEl.textContent = lowerMsg.text;
      lowerMsgEl.classList.add(styles.lowerMsg);
      if (lowerMsg.isBold) {
        lowerMsgEl.classList.add(typographyStyles.smallText_semibold);
      }
      _this.tooltip.appendChild(lowerMsgEl);
    }
  });
  this.width = width || null;
  this.tooltip = document.createElement('section');
  if (testAttribute) {
    this.tooltip.setAttribute('data-qd-test', testAttribute);
  }
  this.tooltip.style.opacity = 0;
  this.tooltip.style.width = width + 'px';
  this.tooltip.classList.add(styles.tooltip);
  this.tooltip.classList.add(typographyStyles.smallText);
  elementToInsertInto.appendChild(this.tooltip);
});

export { Tooltip };
